export default {
  exportUnit: 'Jednotka exportu',
};
